var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FlexiSearchBar from 'bf-library/FlexiSearchBar';
import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { useGetFlexiSearchBarWrapperHooks } from './FlexiSearchBarWrapper.hooks';
import { destinationSelection, getDestinations, getDestinationType } from 'Actions/destinations';
import * as Hotels from 'Actions/hotels';
import * as Search from 'Actions/search';
import * as Settings from 'Actions/settings';
import * as Translations from 'Actions/translations';
import { setConfig } from 'Actions/widgetPool';
import ErrorMessage from 'Components/ErrorMessage';
import { Redirect, WidgetConfigHelper } from 'Helpers';
function FlexiSearchBarWrapper(props) {
    const { sticky = false, TrustYouWidget, intl, isLoading, error, } = props;
    const { searchBarStyle, hideSearchBar, additionalBookingParamClasses, isMultiProperty, effectiveTrustYouId, flexiSearchBarProps, trustYouWidgetProps, handleSearchResults, } = useGetFlexiSearchBarWrapperHooks(props, intl);
    if (!isLoading && error) {
        return (React.createElement(ErrorMessage, null,
            React.createElement(FormattedMessage, { id: "bf.errorOnLoadingData", defaultMessage: "bf.errorOnLoadingData" })));
    }
    return (React.createElement("div", { className: `header-toolbar-wrapper ${sticky ? 'is-sticky' : ''}`, style: searchBarStyle },
        React.createElement("div", { className: "main-container" },
            React.createElement("div", { id: "wrapper-flexi", className: `booking-params-wrapper booking-params-wrapper-flexi ${additionalBookingParamClasses}` },
                !isMultiProperty && !!effectiveTrustYouId && TrustYouWidget ? React.createElement(TrustYouWidget, Object.assign({}, trustYouWidgetProps)) : null,
                !hideSearchBar && (React.createElement(FlexiSearchBar, Object.assign({}, flexiSearchBarProps, { intl: intl, onUpdateResults: handleSearchResults })))))));
}
FlexiSearchBarWrapper.propTypes = {
    intl: intlShape.isRequired,
};
const mapStateToProps = (state, ownProps) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { id } = ownProps;
    const configuration = (_a = state.widgetPool.find((widgetSet) => widgetSet.config.id === id)) === null || _a === void 0 ? void 0 : _a.searchbar;
    return {
        // core data
        settings: state.settings.data,
        search: state.search.data,
        translations: state.translations.data,
        // loading states
        isLoading: state.search.isLoading,
        error: state.search.error,
        // configuration
        channelId: (_b = state.settings) === null || _b === void 0 ? void 0 : _b.data.channelId,
        isMultiProperty: state.settings.data.isMultiProperty,
        configuration,
        // selection and filters
        destinationSelected: (_c = state.destinations) === null || _c === void 0 ? void 0 : _c.selected,
        hotelsFilters: (_d = state.settings.data) === null || _d === void 0 ? void 0 : _d.hotelsFilters,
        filters: state.hotels.filters,
        // codes and external services
        promoCode: (_e = state.search.data) === null || _e === void 0 ? void 0 : _e.clientPromoCode,
        trustYouIdFromRedux: ((_g = (_f = state.offers) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.trustYouId) || ((_k = (_j = (_h = state.offers) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.trustYou) === null || _k === void 0 ? void 0 : _k.id),
        hasAvailabilityIndependentRatePlan: (_l = state.settings.data) === null || _l === void 0 ? void 0 : _l.hasAvailabilityIndependentRatePlan,
    };
};
const mapDispatchToProps = (dispatch) => ({
    // core functions
    getKubeStyling: () => dispatch(Settings.getStyles()),
    getTempSearchParams: () => dispatch((_, getState) => {
        const state = getState();
        const searchData = state.search.data;
        return Promise.resolve({
            checkIn: searchData.checkIn,
            checkOut: searchData.checkOut,
            occupancy: searchData.occupancy,
            promotionalCode: searchData.clientPromoCode,
        });
    }),
    // search actions
    searchResults: (id, isConnected, configuration, destinationSelected, urlParams, isMultiProperty, filters) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(Search.searchResults(id));
        const { channelId, hotels } = configuration;
        const searchFilters = destinationSelected
            ? WidgetConfigHelper.buildFiltersObject(destinationSelected)
            : filters;
        const params = { channelId, hotels, searchFilters };
        if (isConnected) {
            if (isMultiProperty) {
                dispatch(Hotels.getHotelsList(params));
            }
            else {
                yield dispatch(Settings.reloadRatesAndOffers(id));
                yield dispatch(Settings.updateFuturePackages(id));
                yield dispatch(Settings.getStyles());
            }
        }
        else {
            Redirect(urlParams);
        }
    }),
    onChangePromoCode: (id, promoCode) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(Search.changePromoCode(id, promoCode));
    }),
    onChangeCurrency: (id, currency, isMultiProperty) => {
        dispatch(Search.changeCurrency(currency));
        if (!isMultiProperty) {
            dispatch(Settings.reloadRatesAndOffers(id));
        }
    },
    onChangeLanguage: (id, lang, isMultiProperty, channelId, propertyCode) => {
        dispatch(Search.changeLanguage(lang));
        dispatch(Translations.getTranslations(lang, channelId, propertyCode));
        dispatch(Settings.replaceVoucherTerm(lang));
        if (!isMultiProperty) {
            dispatch(Settings.reloadRatesAndOffers(id));
        }
    },
    onChangeDates: (id, dates) => {
        const { startDate, endDate } = dates;
        const checkIn = startDate ? startDate.format('YYYY-MM-DD') : null;
        const checkOut = endDate ? endDate.format('YYYY-MM-DD') : null;
        dispatch(Search.changeDates(id, checkIn, checkOut));
    },
    onChangeRoomsQuantity: (id, numberOfRooms) => dispatch(Search.changeRoomsQuantity(id, numberOfRooms)),
    onRemoveRoom: (id, index) => dispatch(Search.removeRoom(id, index)),
    onChangeAdults: (id, roomIndex, numberOfAdults) => dispatch(Search.changeAdults(id, roomIndex, numberOfAdults)),
    onChangeChildren: (id, roomIndex, numberOfChildren) => dispatch(Search.changeChildren(id, roomIndex, numberOfChildren)),
    onChangeChildrenAge: (id, roomIndex, childIndex, childrenAge) => dispatch(Search.changeChildrenAge(id, roomIndex, childIndex, childrenAge)),
    dispatchGetDestinations: (params) => __awaiter(void 0, void 0, void 0, function* () {
        const body = Object.assign({}, params);
        yield dispatch(getDestinations(body));
    }),
    onDestinationSelected: (selected, id, regionOptions) => __awaiter(void 0, void 0, void 0, function* () {
        const destinationType = yield dispatch(getDestinationType(selected));
        yield dispatch(setConfig(id, 'searchbar', { searchButtonEnabled: true }));
        let countryEnglishName;
        if (destinationType === 'city') {
            countryEnglishName = WidgetConfigHelper.getCountryEnglishName(regionOptions, selected.code);
        }
        const destination = countryEnglishName
            ? Object.assign(Object.assign({}, selected), { type: destinationType, countryEnglishName }) : Object.assign(Object.assign({}, selected), { type: destinationType });
        yield dispatch(destinationSelection(destination));
    }),
    getUrlParams: (id, readable) => dispatch(Search.getURLParams(id, null, null, readable)),
});
const ConnectedFlexiSearchBarWrapper = connect(mapStateToProps, mapDispatchToProps)(FlexiSearchBarWrapper);
const IntlInjectedFlexiSearchBarWrapper = injectIntl(ConnectedFlexiSearchBarWrapper);
export default React.memo(IntlInjectedFlexiSearchBarWrapper);
// i18n labels for reference
// i18nLabel[bf.searchSummaryGuests]
// i18nLabel[bf.searchSummaryRooms]
// i18nLabel[seekda.ba.guest]
// i18nLabel[bf.occupancy]
// i18nLabel[bf.adults]
// i18nLabel[bf.children]
// i18nLabel[bf.roomNumber]
// i18nLabel[bm.availability.bulk.update.dates]
// i18nLabel[bf.accept]
// i18nLabel[bf.apply]
// i18nLabel[widgets.reservations.room.add]
// i18nLabel[bf.maxRoomsPerBooking]
// i18nLabel[bf.maxOccupancyMessage]
// i18nLabel[bf.searchSummaryGuests]
// i18nLabel[bf.searchSummaryRooms]
// i18nLabel[bf.promocode]
// i18nLabel[bf.promocode.inputPlaceholder]
// i18nLabel[bf.occupancy.childAgeSelectorLabelBelowZero]
// i18nLabel[bf.yearsCount]
// i18nLabel[bf.occupancySelector.childrenGuests]
// i18nLabel[bf.forceSelectOccupancySelection]
// i18nLabel[cc.availabilityTab.availabilityPage.label.apply.button]
// i18nLabel[bf.showResults]
